import styled from 'styled-components';

const Button = styled.button`
  appearance: none;
  border: none;
  font: inherit;
  color: inherit;
  display: inline-block;
  background: #8f7a66;
  border-radius: 3px;
  padding: 0 20px;
  text-decoration: none;
  color: #f9f6f2;
  height: 40px;
  line-height: 42px;
  cursor: pointer;
  font-size: 1.25rem;
  font-weight: bold;
  max-width: 150px;
`;

export default Button;
